/**
 * Путь с другим языком: первый сегмент пути заменяется на `language`, остальные
 * сегменты остаются как есть (`/xx/users/1` → `/ru/users/1`). Сегмент из адреса
 * не превращается в регулярное выражение и не может увести на другой сайт:
 * результат всегда начинается с `/<language>`.
 */
export const replaceLanguageSegment = (
  pathname: string,
  language: string
): string => {
  const [, , ...rest] = pathname.split('/');
  return rest.length ? `/${language}/${rest.join('/')}` : `/${language}`;
};
